<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  <v-icon color="white">mdi-account-settings-outline</v-icon>
                  Student CCA Information
               </v-toolbar-title>
               <v-toolbar-title v-else>
                  <v-icon color="white">mdi-account-settings-outline</v-icon>
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-toolbar-items class="pa-2">
                  <v-card max-width="250px" flat color="primary">
                     <v-select
                        dark
                        v-model="termyearselect"
                        :items="termyear"
                        item-text="termyeartext"
                        item-value="id"
                        label="Select"
                        return-object
                        single-line
                        @change="changeTerm"
                     >
                     </v-select>
                  </v-card>
               </v-toolbar-items>
            </v-toolbar>
         </v-col>
      </v-row>
      <v-sheet>
         <v-row no-gutters class="px-2 py-4">
            <v-col cols="6" md="3" class="px-2">
               <v-text-field
                  dense
                  label="Student Code"
                  v-model="studentcode"
                  clearable
                  append-icon="mdi-magnify"
                  @blur="checkStudentCode"
                  @click:append="checkStudentCode"
                  @click:clear="clearStudentCode"
               ></v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="px-2">
               <v-btn small class="ml-2" outlined color="indigo" @click="searchByStudent">
                  <template v-if="$vuetify.breakpoint.mdAndUp">Search By Student</template>
                  <template v-else><v-icon small>mdi-magnify</v-icon>Student</template>
               </v-btn>
            </v-col>
            <v-col cols="12" md="5" class="px-6 pt-1">
               {{ studentinfo.student_fullname }}
            </v-col>
         </v-row>

         <v-sheet outlined>
            <v-row no-gutters>
               <v-col cols="12" md="12">
                  <v-tabs
                     height="40"
                     v-model="studenttab"
                     :slider-color="$globalstore.tab_slidercolor"
                     :show-arrows="!$vuetify.breakpoint.mdAndUp"
                  >
                     <v-tab href="#detail">Details</v-tab>
                     <v-tab href="#profile"
                        >Profile
                        <v-badge
                           v-if="profileinfo.profile_needupdate == true"
                           content="!"
                           color="red"
                           class="ml-2"
                        >
                        </v-badge>
                     </v-tab>
                     <v-tab href="#contact">Contacts</v-tab>
                     <v-tab href="#activity">Activity</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="studenttab">
                     <v-tab-item :key="1" value="detail">
                        <v-card outlined>
                           <v-row>
                              <v-col cols="12" md="5" class="px-5">
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Full Name"
                                    :value="studentinfo.student_fullname"
                                    readonly
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Preferred Name"
                                    :value="studentinfo.preferredname"
                                    readonly
                                 >
                                 </v-text-field>
                              </v-col>
                              <v-col cols="12" md="3" class="px-5">
                                 <v-text-field
                                    class="mt-md-5 mt-0 no-underline"
                                    dense
                                    :label="schoolid_label"
                                    readonly
                                    :value="studentinfo.school_id"
                                    :background-color="studentinfo.is_applicant ? '#ffcdd2' : ''"
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Code"
                                    :value="studentinfo.student_code"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4" class="px-5">
                                 <v-text-field
                                    class="mt-md-5 pr-2 no-underline"
                                    dense
                                    label="Birth Date"
                                    readonly
                                    :value="studentinfo.birthdate"
                                 ></v-text-field>
                                 <v-text-field
                                    class="pr-2 no-underline"
                                    dense
                                    label="Gender"
                                    readonly
                                    :value="studentinfo.gendertext"
                                 ></v-text-field>
                              </v-col>
                           </v-row>
                        </v-card>
                        <v-card outlined>
                           <v-row>
                              <v-col cols="12" md="5" class="pa-5">
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    label="Email Address"
                                    readonly
                                    :value="studentinfo.email_address"
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Mobile Number"
                                    readonly
                                    :value="studentinfo.mobile_number"
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Nationality"
                                    readonly
                                    :value="studentinfo.nationality"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="3" class="pa-5">
                                 <v-text-field
                                    class="mt-md-5 mt-0 no-underline"
                                    dense
                                    label="Academic House"
                                    readonly
                                    :value="studentinfo.academic_house"
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Year"
                                    readonly
                                    :value="studentinfo.yeargrouptext"
                                 ></v-text-field>
                                 <v-text-field
                                    class="no-underline"
                                    dense
                                    label="Form"
                                    readonly
                                    :value="studentinfo.yearform"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4" class="pa-5">
                                 <v-text-field
                                    class="pr-2 mt-2 no-underline"
                                    dense
                                    label="Status"
                                    :value="studentinfo.studentstatustext"
                                 ></v-text-field>
                              </v-col>
                           </v-row>
                        </v-card>
                     </v-tab-item>
                     <v-tab-item :key="2" value="profile">
                        <v-card outlined>
                           <v-row>
                              <v-col cols="12" md="4" class="pa-5">
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Mother's Contact Number"
                                    :value="profileinfo.mother_contactnumber"
                                    readonly
                                 ></v-text-field>
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Father's Contact Number"
                                    :value="profileinfo.father_contactnumber"
                                    readonly
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4" class="pa-5">
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Alternate Contact Name"
                                    :value="profileinfo.alt_contactname"
                                    readonly
                                 ></v-text-field>
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Alternate Contact Number"
                                    :value="profileinfo.alt_contactnumber"
                                    readonly
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4" class="pa-5">
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Alternate Contact Relation"
                                    :value="profileinfo.alt_relationship"
                                    readonly
                                 ></v-text-field>
                                 <v-text-field
                                    class="mt-5 no-underline"
                                    dense
                                    flat
                                    label="Student Mobile Number"
                                    :value="profileinfo.student_mobilenumber"
                                    readonly
                                 ></v-text-field>
                              </v-col>
                           </v-row>
                        </v-card>
                        <v-card outlined>
                           <v-row no-gutters>
                              <v-col cols="12" md="6" class="px-5 pt-5">
                                 <v-textarea
                                    outlined
                                    no-resize
                                    rows="3"
                                    label="Medical Allergies"
                                    :value="profileinfo.medical_allergy"
                                 ></v-textarea>
                              </v-col>
                              <v-col cols="12" md="6" class="px-5 pt-5">
                                 <v-textarea
                                    outlined
                                    no-resize
                                    rows="3"
                                    label="Food Allergies"
                                    :value="profileinfo.food_allergy"
                                 ></v-textarea>
                              </v-col>
                           </v-row>
                           <v-row no-gutters>
                              <v-col cols="12" md="12" class="px-3">
                                 <v-textarea
                                    class="px-2"
                                    outlined
                                    no-resize
                                    rows="4"
                                    label="Remarks"
                                    :value="profileinfo.remarks"
                                 ></v-textarea>
                                 <span class="px-3 caption">
                                    Last Update: {{ profileinfo.last_update }} (
                                    {{ profileinfo.update_by }})</span
                                 >
                              </v-col>
                           </v-row>
                        </v-card>
                     </v-tab-item>
                     <v-tab-item :key="3" value="contact">
                        <v-card outlined>
                           <v-row no-gutters>
                              <v-col cols="12" md="12" class="py-5">
                                 <v-data-table
                                    dense
                                    fixed-header
                                    :items-per-page="-1"
                                    :headers="contact_headers"
                                    item-key="contact_id"
                                    :items="contactinfo"
                                    hide-default-footer
                                 >
                                 </v-data-table>
                              </v-col>
                           </v-row>
                        </v-card>
                     </v-tab-item>
                     <v-tab-item :key="4" value="activity">
                        <v-data-table
                           dense
                           fixed-header
                           :items-per-page="-1"
                           :headers="activity_headers"
                           item-key="cca_id"
                           :items="activityinfo"
                           hide-default-footer
                        >
                           <!-- eslint-disable-next-line -->
                           <template v-slot:item.actions="{item}">
                              <v-btn x-small color="orange" @click="viewAttendance(item)">
                                 <v-icon>mdi-account-outline</v-icon>
                              </v-btn>
                           </template>
                        </v-data-table>
                     </v-tab-item>
                  </v-tabs-items>
               </v-col>
            </v-row>
         </v-sheet>
      </v-sheet>
      <!-- view students attendance -->
      <v-dialog
         v-model="viewattendance"
         width="500px"
         height="300px"
         @keydown.esc="viewattendance = false"
      >
         <v-row no-gutters>
            <v-col cols="12">
               <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                  <v-toolbar-title>
                     {{ attendance_caption }}
                  </v-toolbar-title>
               </v-toolbar>
            </v-col>
         </v-row>
         <v-card>
            <v-data-table
               dense
               fixed-header
               height="30vh"
               :headers="attendance_headers"
               :items="attendancedata"
               hide-default-footer
            >
            </v-data-table>
         </v-card>
      </v-dialog>

      <student-picker ref="pickstudent" @save-selection="saveSelectedStudent"></student-picker>
   </v-container>
</template>

<script>
   import CapConstant from "@/common/capconstant.js";
   import StudentPicker from "@/components/StudentPicker.vue";

   export default {
      inject: ["ShowMessage"],
      components: {StudentPicker},
      data() {
         return {
            termyear: [],
            termyearselect: null,

            studentcode: "",
            studentinfo: {},
            contactinfo: [],
            profileinfo: {},
            activityinfo: [],
            studenttab: "",

            contact_headers: [
               {
                  text: "Name",
                  value: "guardian_name",
                  width: "24%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Account",
                  value: "account_id",
                  width: "9%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Relation",
                  value: "relation_description",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Mobile",
                  value: "mobile_number",
                  width: "14%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Telephone",
                  value: "telephone_number",
                  width: "14%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Email",
                  value: "email_address",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            activity_headers: [
               {
                  text: "Activity",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "cca_description",
                  width: "40%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day",
                  value: "daytext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],

            attendance_col: {
               text: "Attendance",
               value: "actions",
               class: this.$globalstore.table_smallheaderclass,
            },

            viewattendance: false,

            attendance_headers: [
               {
                  text: "Date",
                  value: "event_date",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Attendance",
                  value: "attendstatustext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            attendancedata: [],
            attendance_caption: "",
         };
      },

      computed: {
         schoolid_label() {
            return this.studentinfo.is_applicant ? "School ID (Applicant)" : "School ID";
         },
      },

      methods: {
         checkStudentCode() {
            if (this.studentcode) {
               this.doCheckStudentCode();
            }
         },

         searchByStudent() {
            this.$refs.pickstudent.open();
         },

         clearStudentCode() {
            this.studentcode = "";
            this.studentinfo = {};
            this.profileinfo = {};
            this.activityinfo = [];
         },

         saveSelectedStudent(payload) {
            if (payload) {
               this.studentcode = payload.student_code;
               this.doCheckStudentCode();
            }
         },

         viewAttendance(item) {
            this.viewattendance = true;
            this.attendance_caption = "Attendance: " + item.cca_name;
            this.loadStudentAttendance(item.cca_id);
         },

         async loadStudentAttendance(ccaid) {
            await this.$http({
               url: "/cca/getattendancebystudent.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: ccaid,
                  school_id: this.studentinfo.school_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.attendancedata = response.data.attenddata;
                  }
               }
            });
         },

         SetTermYear() {
            if (this.termyear.length > 0) {
               if (this.$globalstore.currentyear && this.$globalstore.currentterm) {
                  this.termyearselect = this.termyear.find(
                     (x) =>
                        x.year == this.$globalstore.currentyear &&
                        x.term == this.$globalstore.currentterm
                  );
               } else {
                  this.termyearselect = this.termyear.find(
                     (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
                  );
               }
            }
         },

         changeTerm(selectedtermyear) {
            if (selectedtermyear) {
               this.$globalstore.currentyear = selectedtermyear.year;
               this.$globalstore.currentterm = selectedtermyear.term;
               // TODO: Should call different module for better performance
               this.checkStudentCode();
            }
         },

         async doCheckStudentCode() {
            await this.$http({
               url: "/cca/checkstudentcode.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  student_code: this.studentcode,
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     if (!response.data.validstudentcode) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.studentinfo = response.data.studentinfo;
                        this.contactinfo = response.data.contactinfo;
                        this.profileinfo = response.data.profileinfo;
                        this.activityinfo = response.data.activityinfo;
                     }
                  }
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();
            if (this.$globalstore.UserHasCap(CapConstant.VIEW_ATTENDANCE_HISTORY)) {
               this.activity_headers.push(this.attendance_col);
            }
         }
      },
   };
</script>

<style scoped>
   .no-underline >>> .v-input__slot::before {
      border-style: none !important;
   }
</style>
